import apiClient from './client'

export interface SeasonReadiness {
  year: number
  games: number
  plate_appearances: number
  batting_game_rows: number
  batting_season_rows: number
  pitching_game_rows: number
  pitching_season_rows: number
  enriched_batting: number
  enriched_pitching: number
  tier1_batting: number
  tier1_pitching: number
  has_roe_data: boolean
  has_error_position: boolean
  has_hit_location: boolean
  needs_enrichment: boolean
  needs_aggregation: boolean
  enrichment_source_limited: boolean
}

export interface ReadinessResponse {
  seasons: SeasonReadiness[]
}

export const dataApi = {
  async getReadiness(years: string): Promise<ReadinessResponse> {
    const response = await apiClient.get<ReadinessResponse>('/data/readiness', {
      params: { years }
    })
    return response.data
  }
}

export default dataApi
